import { Checkbox, Field } from '@/components/ui';

import type { Option } from './Select';
import { useFieldContext } from './contexts';

type Props = {
  label: string;
  options: Option[];
  helperText?: string;
};

const firstError = (errors: unknown[]) => errors.find((e) => e !== undefined)?.toString();

export function CheckboxGroup({ label, options, helperText }: Props) {
  const field = useFieldContext<string[]>();
  const value = field.state.value ?? [];
  const touched = field.state.meta.isTouched;
  const errMsg = touched ? firstError(field.state.meta.errors) : undefined;

  const toggle = (optValue: string, checked: boolean) => {
    field.handleChange(checked ? [...value, optValue] : value.filter((v) => v !== optValue));
  };

  return (
    <Field label={label} error={errMsg} hint={!errMsg ? helperText : undefined}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {options.map(({ value: optValue, label: optLabel, disabled }) => (
          <Checkbox
            key={optValue}
            label={optLabel}
            checked={value.includes(optValue)}
            disabled={disabled}
            onChange={(checked) => toggle(optValue, checked)}
          />
        ))}
      </div>
    </Field>
  );
}
